<template>
  <div class="restaurant-orders__item">
    <div class="row my-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="">{{ $t('restOrdersItem.orderNo') }} {{ order.id }}
              <div v-if="this.ORDER_IS_UPDATING" class="ms-1 spinner-border spinner-border-sm h4 fw-normal text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </h5>
            <div class="d-flex flex-column flex-md-row justify-content-between">
              <p class="mb-2 mb-md-0">
                {{ $t('restOrdersItem.statuses.created') }} {{ this.friendlyTime(order[`date_created`]) }}
              </p>
              <div class="form-check form-switch">
                <input
                    v-model="orderIsChanging"
                    @click="getModifiersAndOptions"
                    class="form-check-input"
                    type="checkbox" role="switch" id="orderIsChanging" checked>
                <label class="form-check-label user-select-none" for="orderIsChanging">{{ $t('restOrdersItem.edit') }}</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p class="mb-2 fs-6 fw-bold text-muted">{{ $t('restOrdersItem.updateStatus') }}</p>
            <div class="d-flex align-items-center">
              <div class="me-2">
                <select v-model="new_status" class="form-select form-select-sm" >
                  <option disabled value="">{{ $t('restOrdersItem.select') }}</option>
                  <option v-for="(value, key) in statuses" :value="key">
                    {{ value }}
                  </option>
                </select>
                <!--                <div class="input-group input-group-sm flex-nowrap w-auto me-3">-->
                <!--                <span :class="colorForStatus(lastStatus(order.history))" class="order-item__status input-group-text border-secondary border-end-0">-->
                <!--                  {{ this.rusStatus(lastStatus(order.history)) }}-->
                <!--                </span>-->
                <!--                  <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">-->
                <!--                    <span class="visually-hidden">Dropdown</span>-->
                <!--                  </button>-->
                <!--                  <ul class="dropdown-menu py-0" style="font-size: .8rem">-->
                <!--                    <li><a @click="changeStatus('created')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.created') }}</a></li>-->
                <!--                    <li><a @click="changeStatus('accepted')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.accepted') }}</a></li>-->
                <!--                    <li><a @click="changeStatus('preparing')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.preparing') }}</a></li>-->
                <!--                    <li><a @click="changeStatus('ready')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.ready') }}</a></li>-->
                <!--                    <li><a @click="changeStatus('delivering')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.onTheWay') }}</a></li>-->
                <!--                    <li><a @click="changeStatus('completed')" class="dropdown-item" href="#">{{ $t('restOrdersItem.statuses.done') }}</a></li>-->
                <!--                    <li><hr class="dropdown-divider my-1"></li>-->
                <!--                    <li><a @click="changeStatus('rejected')" class="dropdown-item text-danger" href="#">{{ $t('restOrdersItem.statuses.cancelled') }}</a></li>-->
                <!--                  </ul>-->
                <!--                </div>-->
              </div>
              <div class="me-2">
                <label for="statusCommit" class="visually-hidden">{{ $t('restOrdersItem.comment') }}</label>
                <input v-model.trim="this.status_commit" class="form-control form-control-sm" id="statusCommit" :placeholder="$t('restOrdersItem.comment')">
              </div>
              <div class="me-2">
                <button class="btn btn-sm btn-info"
                        :disabled="checkChangeBtn || order.loading"
                        @click="changeStatus(this.new_status)">
                  <span v-show="order.loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t('restOrdersItem.update') }}
                </button>
              </div>
              <!--              <div v-show="order.loading" class="spinner-border spinner-border-sm ms-3" role="status">-->
              <!--                <span class="visually-hidden">Loading...</span>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 mb-4">
        <div class="card">
          <div class="card-body user-select-none">
            <table class="table table-sm table-borderless mb-0"
            :class="this.ORDER_IS_UPDATING ? 'opacity-50' : ''">
              <tbody>
              <tr v-for="(product, key) in order.menu_items" class="border-bottom">
                <td>
                  <div class="d-flex flex-row align-items-center">
                    <div v-if="orderIsChanging" class="d-flex flex-nowrap">
                      <button
                          @click="modalChangeItemInOrder({product: product, index: key})"
                          :disabled="this.ORDER_IS_UPDATING"
                          class="btn btn-outline-secondary p-1 me-2" style="line-height: 1px;">
                        <svg width="1rem" height="1rem" fill="currentColor">
                          <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                        </svg>
                      </button>
                      <button
                          @click="modalRemoveItemInOrder({index: key, title: product.details.title})"
                          :disabled="this.ORDER_IS_UPDATING"
                          class="btn btn-outline-danger p-1 me-2" style="line-height: 1px;">
                        <svg width="1rem" height="1rem" fill="currentColor">
                          <use xlink:href="../../assets/ico/bootstrap-icons.svg#trash3-fill"/>
                        </svg>
                      </button>
                    </div>
                    <div>
                      {{ product.details.title }}
                      <span v-show="product.size" class="small px-1 bg-warning rounded-1">{{ product.size }}</span>
                      <div class="d-flex flex-wrap gap-1">
                        <span class="fs-08rem fst-italic text-secondary small"
                              :class="option.removed ? 'text-decoration-line-through' : ''"
                              v-for="option in optionToProduct(product.selected_modifiers)" :key="option.id">
                          {{ option.title }}
                          <span v-show="!option.removed">({{ option.qty }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-nowrap align-items-center gap-1">
                    <div>{{ product.qty }}</div>
                    <span class="small">{{ $t('restOrdersItem.qty') }}</span>
                  </div>
                </td>
                <td class="text-end" v-text="product.amount"></td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="d-flex justify-content-between">
                    <div>
                      <button v-if="orderIsChanging"
                              @click="modalAddItemInOrder()"
                              class="btn btn-outline-success p-1 me-2" style="line-height: 1px;">
                        <svg width="1rem" height="1rem" fill="currentColor">
                          <use xlink:href="../../assets/ico/bootstrap-icons.svg#plus-lg"/>
                        </svg>
                      </button>
                    </div>
                    <div class="text-end fw-bold">
                      {{ order.amount }}
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <div class="card">
          <div class="card-header">
            {{ $t('restOrdersItem.statusHistory') }}
          </div>
          <div class="card-body">
            <table class="table table-sm table-border mb-0"
                   :class="this.ORDER_IS_UPDATING ? 'opacity-50' : ''">
              <tbody>
                <tr v-for="status in order.history" :key="status.datetime">
                  <td>
                    <span :class="colorForStatus(status.status)" class="badge">
                      {{ rusStatus(status.status) }}
                    </span>
                  </td>
                  <td v-text="friendlyTime(status.datetime)"></td>
                  <td>
                    <svg v-show="status.comment" width="1.5rem" height="1.5rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="status.comment">
                      <use xlink:href="../../assets/ico/bootstrap-icons.svg#chat-text"/>
                    </svg>
                  </td>
                  <td>
                    <svg width="1.5rem" height="1.5rem" fill="green" data-bs-toggle="tooltip" data-bs-placement="top" :title="status.updated_by">
                      <use xlink:href="../../assets/ico/bootstrap-icons.svg#person-circle"/>
                    </svg>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12 col-md-4 mb-4">
        <div class="card">
          <div class="card-header">
            {{ $t('restOrdersItem.customer') }}
          </div>
          <div class="card-body">
            {{ order.user_name }}<br>
            {{ order.user_phone_number }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <div class="card">
          <div class="card-header">
              <button
                  v-if="orderIsChanging"
                  @click="modalChangeOrderDelivery()"
                  :disabled="this.ORDER_IS_UPDATING"
                  class="btn btn-outline-secondary p-1 me-2" style="line-height: 1px;">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                </svg>
              </button>
            {{ $t('restOrdersItem.delivery') }}
          </div>
          <div class="card-body">
            <div v-if="order.delivery_method === 'delivery'">
              <b>{{ $t('restOrdersItem.deliveryPrice') }}</b>: {{order.delivery_price}}
              <hr class="my-2">
              {{ order.delivery_address }}
            </div>
            <div v-else-if="order.delivery_method === 'pickup'">
              {{ $t('restOrdersItem.pickup') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <div class="card">
          <div class="card-header">
            {{ $t('restOrdersItem.info') }}
          </div>
          <div class="card-body">
            {{ order.comment }}
          </div>
        </div>
      </div>
    </div>
    <order-item-remove v-bind:product="itemForRemove"></order-item-remove>
    <order-item-change
        v-bind:product="itemForChange"
        v-bind:index="itemIndexForChange"
        ref="childComponent">
    </order-item-change>
    <order-item-add ref="childOrderItemAdd"></order-item-add>
    <order-delivery-change ref="orderDeliveryChange"></order-delivery-change>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import i18n from "@/i18n";
import router from "@/router"
import {Modal, Tooltip} from "bootstrap";
import OrderItemRemove from "@/components/restaurant_item/modal_in_order_item/OrderItemRemove";
import OrderItemChange from "@/components/restaurant_item/modal_in_order_item/OrderItemChange";
import OrderItemAdd from "@/components/restaurant_item/modal_in_order_item/OrderItemAdd";
import OrderDeliveryChange from "@/components/restaurant_item/modal_in_order_item/OrderDeliveryChange";
export default {
  name: "RestOrdersItem",
  components: {OrderItemChange, OrderItemRemove, OrderItemAdd, OrderDeliveryChange },
  data() {
    return {
      new_status: '',
      status_commit: '',
      orderIsChanging: false,
      itemForRemove: {},
      itemForChange: {},
      itemIndexForChange: 0,
      statuses: {
        created: i18n.global.t('restOrdersItem.statuses.created'),
        accepted: i18n.global.t('restOrdersItem.statuses.accepted'),
        preparing: i18n.global.t('restOrdersItem.statuses.preparing'),
        ready: i18n.global.t('restOrdersItem.statuses.ready'),
        delivering: i18n.global.t('restOrdersItem.statuses.onTheWay'),
        completed: i18n.global.t('restOrdersItem.statuses.done'),
        rejected: i18n.global.t('restOrdersItem.statuses.cancelled'),
      }
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANT',
      'RESTAURANTORDERS',
      'RESTAURANT_ORDER_ITEM',
      'LOADING',
      'ORDER_IS_UPDATING',
    ]),
    order() {
      return this.RESTAURANT_ORDER_ITEM
      // return this.RESTAURANTORDERS[this.$route.params.orderIndex]
    },
    checkChangeBtn() {
      if(this.new_status === '' || this.status_commit === '') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    getOrder() {
      let payload = {
        orderId: this.$route.params.orderId,
        restId: this.$route.params.id
      }
      this.$store.dispatch('getRestaurantOrderItem', payload)
    },
    friendlyTime(e) {
      let date = new Date(e)
      let options = {
        era: undefined,
        year: '2-digit',
        month: '2-digit',
        day: 'numeric',
        weekday: undefined,
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      };
      return date.toLocaleString("ru", options)
    },
    rusStatus(status) {
      if (status === 'created') {return i18n.global.t('restOrdersItem.statuses.created')}
      if (status === 'accepted') {return i18n.global.t('restOrdersItem.statuses.accepted')}
      if (status === 'preparing') {return i18n.global.t('restOrdersItem.statuses.preparing')}
      if (status === 'ready') {return i18n.global.t('restOrdersItem.statuses.ready')}
      if (status === 'delivering') {return i18n.global.t('restOrdersItem.statuses.onTheWay')}
      if (status === 'completed') {return i18n.global.t('restOrdersItem.statuses.done')}
      if (status === 'rejected') {return i18n.global.t('restOrdersItem.statuses.cancelled')}
    },
    colorForStatus(status) {
      if (status === 'created') {return 'bg-black text-white'}
      if (status === 'accepted') {return 'bg-info'}
      if (status === 'preparing') {return 'bg-warning text-dark'}
      if (status === 'ready') {return 'bg-success'}
      if (status === 'delivering') {return 'bg-primary text-white'}
      if (status === 'completed') {return 'bg-secondary text-white'}
      if (status === 'rejected') {return 'bg-danger'}
    },
    lastStatus(history) {
      return history[history.length - 1].status
    },
    changeStatus(status) {
      let restId = this.$route.params.id
      let orderId = this.$route.params.orderId
      this.$store.commit('addSpinnerToOrder', orderId)
      let requestBody = {
        'status': status,
        'comment': this.status_commit
      }
      this.status_commit = ''
      this.new_status = ''
      let payload = { restId, orderId, requestBody }
      this.$store.dispatch('addOrderStatus', payload)
    },
    optionToProduct(selected_modifiers) {
      const modifiers = Object.values(selected_modifiers)
      const options = []
      for (let mod in modifiers) {
        for (let opt in modifiers[mod]) {
          options.push(modifiers[mod][opt])
        }
      }
      return options
    },
    //:TODO change order
    getModifiersAndOptions() {
      let restId = this.$route.params.id
      this.$store.dispatch('getModifiers', restId)
      this.$store.dispatch('getOptions', restId)
    },
    modalRemoveItemInOrder(elem) {
      this.itemForRemove = elem
      const removeModal = new Modal(document.querySelector('#modalRemoveItemInOrder'));
      removeModal.show();
    },
    modalChangeItemInOrder(elem) {
      this.itemForChange = elem.product
      this.itemIndexForChange = elem.index
      this.$refs.childComponent.setInfoProduct(elem.product) //вызываем метод в дочернем компоненте и передаем туда product
      const changeModal = new Modal(document.querySelector('#modalChangeItemInOrder'));
      changeModal.show();
    },
    modalAddItemInOrder() {
      this.$refs.childOrderItemAdd.clearProductIndex() //очищаем index переод открытием
      const changeModal = new Modal(document.querySelector('#modalAddItemInOrder'));
      changeModal.show();
    },
    modalChangeOrderDelivery() {
      let method = this.order.delivery_method
      let address = this.order.delivery_address
      this.$refs.orderDeliveryChange.setData(method, address)
      const removeModal = new Modal(document.querySelector('#modalChangeDelivery'));
      removeModal.show();
    },
  },
  mounted() {
    this.getOrder()
    //breadcrumbs
    this.$breadcrumbs.value[4].label = this.$route.params.orderId
    //initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  },
}
</script>

<style scoped>

</style>
